<template>
  <component :is="tagIs">
    <span class="detail-title">Burn Estimate</span>
    <span class="detail-value -estimate">
      <icon-button
        type="button"
        class="-ico-only -no-container"
        :icon="user.showBurnEstimates ? 'visibility_off' : 'visibility'"
        label="Calories"
        :aria-expanded="user.showBurnEstimates ? 'true' : 'false'"
        @click-action="handleVisibilityToggle"
      />
      <span
        v-show="user.showBurnEstimates"
        :aria-hidden="user.showBurnEstimates ? 'false' : 'true'"
        >{{ calorieRange }}</span
      >
    </span>
  </component>
</template>

<script>
import { mapActions, mapState } from 'pinia'
import { useUserAuthStore } from '@/stores/user-auth'
import IconButton from '@/components/buttons/icon-button.vue'
import { fbApi } from '@/utils/http-api'

/**
 * Burn estimate that shows / hides.  Defaults to hidden.
 */
export default {
  name: 'BurnEstimate',
  components: { IconButton },
  props: {
    tagIs: {
      type: String,
      default: 'li',
    },
    burnMin: {
      type: Number,
      required: true,
    },
    burnMax: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState(useUserAuthStore, ['user']),

    calorieRange() {
      return `${this.burnMin}-${this.burnMax} Calories`
    },
  },
  methods: {
    ...mapActions(useUserAuthStore, ['updateUser']),

    handleVisibilityToggle() {
      const isExpanded = !this.user.showBurnEstimates

      // fire API call to update user setting, but do not wait for response
      if (this.user.isLoggedIn) {
        fbApi.put(`/my/account`, {
          skipErrorModal: true,
          json: {
            show_burn_estimates: isExpanded,
          },
        })
      }

      // update user setting in pinia
      this.updateUser({
        showBurnEstimates: isExpanded,
      })
    },
  },
}
</script>
